module.exports = __webpack_public_path__ + "img/ws.f4fea930.svg";